function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledFavourites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.5,
    height: 19.333,
    viewBox: "0 0 21.5 19.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/favourits",
    d: "M1147 35a4.976 4.976 0 0 0-5 4.95c0 2.207.88 7.445 9.49 12.74a.978.978 0 0 0 1.02 0c8.61-5.295 9.49-10.533 9.49-12.74a4.976 4.976 0 0 0-5-4.95c-2.76 0-5 3-5 3s-2.24-3-5-3z",
    transform: "translate(-1141.25 -34.25)",
    style: {
      fill: "#ff4858",
      stroke: "#ff4858",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFavourites);
export default __webpack_public_path__ + "static/media/filled_favourites.54904e4f.svg";
export { ForwardRef as ReactComponent };